
import {
  defineComponent,
  reactive, ref, provide,
} from 'vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { useGradeBase } from '@/core/composables/GradeBase';
import Card from '@/core/components/Tela/Card.vue';
import { EOrigemRecebimentoMercadoria } from '@/models/Enumeradores/Compras/EOrigemRecebimentoMercadoria';
import SelecionarDataInicialFinal from '@/core/components/Tela/SelecionarDataInicialFinal.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import Totalizador from '@/core/components/Tela/Totalizador.vue';
import storeSistema from '@/store/storeSistema';
import SelecionarEmpresa from '@/components/MeuSistema/Empresas/SelecionarEmpresa.vue';
import SelecionarEstoque from '@/components/Cadastros/Estoques/SelecionarEstoque.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import SelecionarPeriodoMovimento from '@/components/Estoques/MovimentoEstoque/SelecionarPeriodoMovimento.vue';
import SelecionarRecursoMovimento from '@/components/MeuSistema/SelecionarRecursoMovimento.vue';
import { IParametrosConsultaMovimentoEstoque } from '@/models/ParametrosRequisicao/Estoques/MovimentoEstoque/IParametrosConsultaMovimentoEstoque';
import { EPeriodoMovimentoEstoque } from '@/models/Enumeradores/Estoques/MovimentoEstoque/EPeriodoMovimentoEstoque';
import { ETipoMovimentoEstoque } from '@/models/Enumeradores/Estoques/MovimentoEstoque/ETipoMovimentoEstoque';
import ServicoMovimentoEstoque from '@/servicos/Estoques/ServicoMovimentoEstoque';
import { IDTOMovimentoEstoque, IDTOMovimentoEstoqueConsulta } from '@/models/DTO/Estoques/MovimentoEstoque/IDTOMovimentoEstoque';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import TituloPadrao from '@/core/components/Tela/TituloPadrao.vue';
import RecebimentoMercadorias from '@/views/Compras/RecebimentoMercadorias/RecebimentoMercadoriasModal.vue';
import VendaModal from '@/views/Vendas/Vendas/VendaModal.vue';
import ServicoVendas from '@/servicos/Vendas/ServicoVendas';
import OrdemProducaoModal from '@/views/PCP/OrdemProducao/OrdemProducaoModal.vue';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { ITelaOperacao } from '@/core/models/ITelaOperacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import { IRecebimentoMercadoria } from '@/models/Entidades/Compras/IRecebimentoMercadoria';
import { ETipoPermissao } from '@/models/Enumeradores/MeuSistema/Usuarios/ETipoPermissao';
import ServicoProcessoVendas from '@/servicos/Cadastros/Vendas/ServicoProcessoVendas';
import { IProcessoVendas, IEtapaProcessoVendas } from '@/models/Entidades/Cadastros/Vendas/IProcessoVendas';
import { IDTODadosEmpresa } from '@/models/DTO/MeuSistema/Empresas/IDTODadosEmpresa';
import ServicoSistema from '@/servicos/MeuSistema/ServicoSistema';

export default defineComponent({
  name: 'MovimentacaoEstoque',
  components: {
    Card,
    TituloPadrao,
    SelecionarDataInicialFinal,
    MensagemSemDados,
    Totalizador,
    SelecionarEmpresa,
    SelecionarEstoque,
    SelecionarRecursoMovimento,
    SelecionarProduto,
    SelecionarPeriodoMovimento,
    RecebimentoMercadorias,
    VendaModal,
    OrdemProducaoModal,
  },
  setup(props) {
    const {
      telaBase, obterPermissoes, adicionarAtalho, removerAtalho, apresentarMensagemAlerta,
    } = useTelaBase();

    const { gradeBase } = useGradeBase();
    const servicoMovimentoEstoque = new ServicoMovimentoEstoque();
    const servicoVendas = new ServicoVendas();
    const servicoProcessoVendas = new ServicoProcessoVendas();
    servicoProcessoVendas.requisicaoSistema();
    const processoVendas = ref<IProcessoVendas>({} as IProcessoVendas);
    const etapaLancamento = ref<IEtapaProcessoVendas>({} as IEtapaProcessoVendas);
    const dadosEmpresa = ref<IDTODadosEmpresa>({} as IDTODadosEmpresa);
    const permissaoServico = ref<boolean>(false);

    provide('VENDAS_EMPRESA', dadosEmpresa);
    provide('VENDAS_PROCESSO_VENDAS', processoVendas);
    provide('VENDAS_ETAPA_LANCAMENTO', etapaLancamento);
    provide('VENDAS_PERMISSAO_SERVICO', permissaoServico);

    // Constantes para os nomes dos recursos (assumindo que são esses os valores em record.recurso)
    const RECURSO_RECEBIMENTO_MERCADORIA = 'Recebimentos de Mercadorias';
    const RECURSO_VENDA = 'Painel de Vendas';
    const RECURSO_ORDEM_PRODUCAO = 'Ordem de Produção';
    const state = reactive({
      larguraGrade: window.innerWidth,
      parametrosConsulta: {} as IParametrosConsultaMovimentoEstoque,
      movimentoConsulta: {} as IDTOMovimentoEstoqueConsulta,
      controleResultado: 1,
      codigoEmpresa: 0,
      saldoInicial: 0,
      totalEntradas: 0,
      totalSaidas: 0,
      saldoBloqueado: 0,
      saldoFinal: 0,
      casasDecimaisTotalizadores: 2,
      operacaoLancamento: {} as ITelaOperacao,
      showRecebimentoMercadoriaModal: false,
      showVendaModal: false,
      currentVendaId: 0,
      showOrdemProducaoModal: false,
      currentOrdemProducaoId: 0,
      recebimentoMercadoriaImportacao: {} as IRecebimentoMercadoria,
      identificadorRecurso: 'MOVIMENTACAO_ESTOQUE',
      identificadorPermissao: 'PER_MOVIMENTACAO_ESTOQUE',
    });

    state.parametrosConsulta.periodo = EPeriodoMovimentoEstoque.MesAtual;
    state.codigoEmpresa = storeSistema.getters.codigoEmpresaOperacao();

    gradeBase.colunas = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Recurso', dataIndex: 'recurso', key: 'Recurso', ellipsis: true, width: 100, position: 1, visible: true, ordering: false, align: 'left',
      },
      {
        title: 'Documento', dataIndex: 'numeroDocumento', key: 'numeroDocumento', ellipsis: true, width: 75, position: 2, visible: true, customRenderRow: ECustomRenderRow.LinkAcao, align: 'left',
      },
      {
        title: 'Nome da pessoa', dataIndex: 'nomePessoaMovimento', key: 'nomePessoaMovimento', ellipsis: true, width: 175, position: 3, visible: true, ordering: false, align: 'left',
      },
      {
        title: 'Data', dataIndex: 'data', key: 'Data', width: 100, position: 4, visible: true, ordering: false, align: 'center',
      },
      {
        title: 'UN', dataIndex: 'unidade', key: 'Unidade', ellipsis: true, width: 50, position: 5, visible: true, ordering: false, align: 'center',
      },
      {
        title: 'Quantidade', dataIndex: 'quantidade', key: 'Quantidade', position: 6, width: 100, visible: true, ordering: false, align: 'right',
      },
      {
        title: 'Codigo Origem Movimento', dataIndex: 'codigoOrigemMovimento', key: 'CodigoOrigemMovimento', position: 6, width: 100, visible: false, ordering: false, align: 'right',
      },
    ];

    function montaApresentacaoQuantidade(movimentoEstoque: IDTOMovimentoEstoque): string {
      let quantidadeFormatada = '0';

      quantidadeFormatada = UtilitarioMascara.mascararValor(movimentoEstoque.quantidade, movimentoEstoque.casasDecimais);
      switch (movimentoEstoque.tipoMovimento) {
        case ETipoMovimentoEstoque.Entrada:
          quantidadeFormatada += ' Entrada';
          break;
        case ETipoMovimentoEstoque.Saida:
          quantidadeFormatada += ' Saída';
          break;
        case ETipoMovimentoEstoque.Bloqueio:
          quantidadeFormatada += ' B';
          break;
        default:
          quantidadeFormatada += ' ';
      }

      return quantidadeFormatada;
    }

    function limparInformacoesBusca() {
      state.controleResultado += 1;
      state.saldoInicial = 0;
      state.totalEntradas = 0;
      state.totalSaidas = 0;
      state.saldoBloqueado = 0;
      state.saldoFinal = 0;
      state.casasDecimaisTotalizadores = 2;
      state.parametrosConsulta.empresas = [];
      state.parametrosConsulta.empresas.push(state.codigoEmpresa);
      state.movimentoConsulta = {} as IDTOMovimentoEstoqueConsulta;
      state.recebimentoMercadoriaImportacao = {} as IRecebimentoMercadoria;
    }

    async function buscarMovimentacoes() {
      limparInformacoesBusca();

      if (!UtilitarioGeral.validaCodigo(state.parametrosConsulta.codigoProdutoDefinicao)) {
        apresentarMensagemAlerta('É necessário selecionar um produto!');
        return;
      }
      gradeBase.nenhumRegistroEncontrado = false;
      gradeBase.buscandoDados = true;
      state.movimentoConsulta = await servicoMovimentoEstoque.obterMovimentacoes(state.parametrosConsulta);
      state.saldoInicial = state.movimentoConsulta.saldoInicial;
      state.totalEntradas = state.movimentoConsulta.totalEntradas ? state.movimentoConsulta.totalEntradas : 0;
      state.totalSaidas = state.movimentoConsulta.totalSaidas ? state.movimentoConsulta.totalSaidas : 0;
      state.saldoFinal = state.movimentoConsulta.saldoFinal ? state.movimentoConsulta.saldoFinal : 0;

      if (UtilitarioGeral.validaLista(state.movimentoConsulta.movimento)) {
        state.casasDecimaisTotalizadores = state.movimentoConsulta.movimento[0].casasDecimais;
      } else {
        gradeBase.nenhumRegistroEncontrado = true;
      }

      gradeBase.buscandoDados = false;
    }

    async function onRecebimentoMercadoriaModalClose() {
      state.showRecebimentoMercadoriaModal = false;
    }

    async function onVendaModalClose() {
      state.showVendaModal = false;
      state.currentVendaId = 0;
    }

    async function onOrdemProducaoModalClose() {
      state.showOrdemProducaoModal = false;
      state.currentOrdemProducaoId = 0;
    }

    async function abrirModalRecurso(record: IDTOMovimentoEstoque) {
      if (!UtilitarioGeral.validaCodigo(record.codigoOrigemMovimento)) {
        apresentarMensagemAlerta(
          'Não foi possível identificar o código de origem do movimento.',
        );
        return;
      }

      switch (record.recurso) {
        case RECURSO_RECEBIMENTO_MERCADORIA:
          try {
            state.identificadorRecurso = 'RECEBIMENTOS_MERCADORIAS';
            state.identificadorPermissao = 'PER_RECEBIMENTOS_MERCADORIAS';
            telaBase.identificadorRecurso = state.identificadorRecurso;
            telaBase.identificadorPermissao = state.identificadorPermissao;
            state.operacaoLancamento = {} as ITelaOperacao;
            state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Alterar;
            state.operacaoLancamento.codigoRegistro = record.codigoOrigemMovimento;
            state.operacaoLancamento.empresaSelecionada = state.codigoEmpresa;
            await obterPermissoes(ETipoPermissao.Dados);
            state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
            state.showRecebimentoMercadoriaModal = true;
          } catch (error) {
            apresentarMensagemAlerta('Erro ao carregar Recebimento de Mercadoria.');
          }
          break;
        case RECURSO_VENDA:
          try {
            telaBase.carregando = true;

            const venda = await servicoVendas.obter(record.codigoOrigemMovimento);
            if (!venda) {
              apresentarMensagemAlerta('Venda não encontrada.');
              return;
            }

            processoVendas.value = await servicoProcessoVendas.obterProcessoCompletoCache(venda.codigoProcessoVendas, venda.codigoEmpresa);
            if (!processoVendas.value) {
              apresentarMensagemAlerta('Processo de vendas não encontrado.');
              return;
            }

            const indexEtapa = processoVendas.value.etapas.findIndex((e) => e.codigo === venda.codigoEtapaProcessoVendas);
            if (indexEtapa === -1) {
              apresentarMensagemAlerta('Etapa da venda não encontrada no processo.');
              return;
            }
            etapaLancamento.value = processoVendas.value.etapas[indexEtapa];

            const dadosEmpresaCache = storeSistema.state.empresasDisponiveis.find((c) => c.codigoEmpresa === venda.codigoEmpresa);
            if (dadosEmpresaCache) {
              dadosEmpresa.value = dadosEmpresaCache;
            }
            permissaoServico.value = await new ServicoSistema().validarPermissaoModulo(venda.codigoEmpresa, 8);

            state.currentVendaId = record.codigoOrigemMovimento;
            state.showVendaModal = true;
          } catch (error) {
            apresentarMensagemAlerta('Erro ao carregar dados da venda.');
          } finally {
            telaBase.carregando = false;
          }
          break;
        case RECURSO_ORDEM_PRODUCAO:
          state.operacaoLancamento = {} as ITelaOperacao;
          state.operacaoLancamento.tipoPermissaoDados = EPermissaoDados.Visualizar;
          state.operacaoLancamento.listaPermissoesDados = telaBase.listaPermissoesDados;
          state.operacaoLancamento.codigoRegistro = record.codigoOrigemMovimento;
          state.operacaoLancamento.empresaSelecionada = state.codigoEmpresa;
          state.currentOrdemProducaoId = record.codigoOrigemMovimento;
          state.showOrdemProducaoModal = true;
          break;
        default:
          apresentarMensagemAlerta('Recurso não suportado para visualização detalhada.');
          break;
      }
    }

    function preparaMensagemGrade():string {
      if (gradeBase.buscandoDados) {
        return 'Buscando informações, por favor aguarde...';
      }

      if (gradeBase.nenhumRegistroEncontrado) {
        return 'Nenhuma movimentação foi encontrada, verifique os seus filtros...';
      }

      return 'Preencha os filtros para localizar as movimentações';
    }

    function atualizarSelecaoEmpresas() {
      limparInformacoesBusca();
      state.parametrosConsulta.codigoProdutoDefinicao = 0;
      state.parametrosConsulta.estoques = undefined;
    }
    return {
      props,
      state,
      telaBase,
      gradeBase,
      storeSistema,
      EPeriodoMovimentoEstoque,
      EOrigemRecebimentoMercadoria,
      UtilitarioData,
      atualizarSelecaoEmpresas,
      adicionarAtalho,
      removerAtalho,
      preparaMensagemGrade,
      buscarMovimentacoes,
      montaApresentacaoQuantidade,
      limparInformacoesBusca,
      onRecebimentoMercadoriaModalClose,
      onVendaModalClose,
      onOrdemProducaoModalClose,
      abrirModalRecurso,
      ECustomRenderRow,
    };
  },
});
